import { Component, Inject, Input, LOCALE_ID } from '@angular/core';
import { Router } from '@angular/router';
import { AlertService, ItemToSell, ItemToSellState, ItemsToSellService } from 'src/app/_services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'compact-listing-buttons',
  templateUrl: './compact-listing-buttons.component.html',
  styleUrls: ['./compact-listing-buttons.component.scss']
})
export class CompactListingButtonsComponent {
  
  @Input()
  item: ItemToSell;
  
  @Input()
  editNextPage: string | undefined;
  
  constructor(
    private router: Router,
    private itemsToSellService: ItemsToSellService,
    private alertService: AlertService,
    @Inject(LOCALE_ID) private locale: string) {
  }
  
  toEdit() {
    this.router.navigate(['/edit-listing/' + this.item.id, { nextPage: this.editNextPage }]);
  }
  
  getItemURL(): string {
    return `${environment.baseURL}/${this.locale}/view-listing/${this.item.id}`;
  }
  
  async removeListing() {
    
    if (!this.item) {
      return;
    }
    
    try {
      console.log("Removing listing");
      this.item.state = ItemToSellState.READY_FOR_LISTING;
      await this.itemsToSellService.updateAsync(this.item);
    } catch (e) {
      this.alertService.showError($localize `Error removing listing`);
      return;
    }
    
    this.alertService.showSuccess($localize `Listing removed successfully`);
    this.router.navigate(["/items-to-sell"]);
  }
}
